<template>
  <modelframe>
    <div class="acountSet">
      <el-form :model="userData" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="password">
          <el-input type="password" v-model="userData.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="userData.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword">
          <el-input type="password" v-model="userData.checkPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('userData')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </modelframe>
</template>

<script>
export default {
  name: "modifyPassword",
  components:{
  },
  data(){
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else {
        callback();
      }
    };
    let validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        this.$refs.ruleForm.validateField('checkPassword');
        callback();
      }
    };
    let validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value.toString() !== this.userData.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userData: {
        password: '',
        username:'',
        newPassword: '',
        checkPassword: '',
      },
    rules: {
      password: [
        { validator: validatePass, trigger: 'blur' },
        { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
      ],
      newPassword: [
        { validator: validateNewPass, trigger: 'blur' },
        { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
      ],
      checkPassword: [
        { validator: validateCheckPass, trigger: 'blur' },
        { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
      ]
    }
    }
  },
  methods:{

    submitForm() {
      this.$refs.ruleForm.validate(async (valid) =>{
        if (valid){
          this.userData.username=localStorage.getItem('username');
          // console.log('密码修改成功',this.userData)
          this.$api.changePassWord(this.userData.password,this.userData.username,this.userData.newPassword).then((result)=>{
            if (result){
              this.$message.success('密码修改成功');
              localStorage.removeItem('token');
              this.$store.commit('toPage','/home');
            }else {
              this.$message.error('密码修改失败');
            }
          },error=>{
            console.log(error.message);
          })


        }else {
          return false;
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
}
</script>

<style scoped>
  .acountSet{
    position: relative;
    margin:auto;
    top: 30px;
    text-align: center;
    vertical-align: center;
    width: 400px;
    height:fit-content;
    padding-bottom: 35px;
  }
  .check-code-btn{
    display:inline-block;
    position: absolute;
    top: 2px;
    padding-left:9px;
    width:90px;
    left:130px;
  }
  .check-code-input{
    display:flex;
    justify-self:left;
    width:100px;
  }
</style>
